export default function IconExpandTriangle(props) {
  return (
    <svg width="7" height="7" viewBox="0 0 8 8" fill="currentColor" {...props}>
      <path d="M2 1l4 3-4 3V1z"/>
    </svg>
  )
}
